<template>
  <div class="reimbursement-container">
    <!-- 标题区域，可替换成更合适的医保相关图标 -->
    <div class="title-section">
      <img style="   width: 70px;"
        src="../../assets/yyimages/yb-1.jpg"
        alt="医保图标"
        class="insurance-icon"
      />
      <h1>医保费用报销须知</h1>
    </div>

    <!-- 条件部分 -->
    <div class="item-section">
      <h2>一、报销医药费用需同时符合下列条件</h2>
      <p>请出示身份证或电子医保凭证</p>
      <ul>
        <li>患者已参加当年度职工医保或城乡居民医保；</li>
        <li>患者本人因疾病就诊产生的医保可报销费用。</li>
      </ul>
    </div>

    <!-- 公式部分 -->
    <div class="item-section">
      <h2>二、报销计算公式</h2>
      <p class="formula">（医药费用 - 自付费用 - 起付线）× 报销比例</p>
    </div>

    <!-- 政策部分 -->
    <div class="item-section">
      <h2>三、报销政策（卫生院或社区卫生服务中心 ）</h2>
      <div class="policy-types">
        <div class="policy-card">
          <h3>职工医保</h3>
          <ul>
            <li>住院起付线：200元<br />报销比例：93%（在职）、95%（退休）</li>
            <li>普门起付线：0元<br />报销比例：70%</li>
            <li>职工医保门诊报销额度<br />在职：1500元/年、退休：2000元/年</li>
          </ul>
        </div>
        <div class="policy-card">
          <h3>城乡居民医保</h3>
          <ul>
            <li>住院起付线：200元<br />报销比例：85%</li>
            <li>普门起付线：0元<br />报销比例：70%</li>
            <li>两病门诊：<br />糖尿病报销额度：600元/年<br />高血压报销额度：360元/年</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 备注部分 -->
    <div class="item-section">
      <h2>备注</h2>
      <p>目前，因系统原因，株洲市市本级参保人住院直报限于芦淞区，天元区，荷塘区，石峰区，云龙区，渌口区的参保人员</p>
      <p>株洲市市本级参保人门诊直报限于芦淞区，天元区，荷塘区，石峰区，云龙区的参保人员</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsuranceReimbursement'
}
</script>

<style scoped>
/* 整体容器样式，白底、居中、设置内边距等 */
.reimbursement-container {
  width: 80%;
  margin: 0 auto;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.8s ease-out forwards;
}

/* 标题区域样式，让图标和标题排版更协调 */
.title-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.insurance-icon {
  margin-right: 10px;
}

/* 每个板块的通用样式，增加间距 */
.item-section {
  margin-bottom: 30px;
}
.item-section h2 {
  color: #333;
  border-left: 5px solid #009688;
  padding-left: 10px;
  margin-bottom: 15px;
}
.item-section p {
  line-height: 1.6;
  color: #666;
}
.item-section ul {
  list-style: disc;
  margin-left: 20px;
  color: #666;
  line-height: 1.6;
}

/* 公式样式，突出显示 */
.formula {
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  color: #333;
  font-weight: bold;
}

/* 两种医保政策卡片布局 */
.policy-types {
  display: flex;
  gap: 20px;
}
.policy-card {
  flex: 1;
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
}
.policy-card h3 {
  color: #009688;
  margin-bottom: 10px;
}

/* 入场动画，让内容有渐变显示、上移效果 */
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>